/*
 * PACK MATCH — parcours guidés en 2 ou 3 étapes (v4)
 * ---------------------------------------------------------------------------
 * - Pack Match : 1 maillot + 1 short de match du même sport. Le prix du pack
 *   est appliqué par la fonction de remise « pack-match-discount ».
 * - Pack Pétanque (v4) : polo + sweat zippé + bas de survêtement, même remise.
 * - Offre de rentrée : débardeur Élite + slip de bain, 1 slip offert par
 *   débardeur dès 30 débardeurs (fonction « debardeur-slip-offert »).
 * Ce script ne calcule aucun prix : il guide le client, les remises sont
 * appliquées au panier par les fonctions de l'app Claude.
 *
 * Chargé par : la section « Nos promotions » (accueil), la fiche produit et le
 * panier. Chaque page appelle UNE fonction d'initialisation ; le module ne
 * lance rien tout seul.
 *
 * Parcours : bouton « Composer mon pack <sport> » (data-pack-match-start) ou
 * lien « …?parcours=<id> » → étape 1, fiche du 1er produit → ajout au panier →
 * étape 2, fiche du 2e produit → ajout au panier → le panier, qui sert de récap.
 *
 * Mécanique reprise de pack-summer.js (voir ce fichier pour le détail) :
 *  1. On n'entre dans un parcours QUE par un de ces boutons ou liens.
 *  2. Seul le produit « armé » (celui de l'étape en cours) fait avancer le
 *     parcours : un produit ajouté hors parcours ne déclenche rien.
 *  3. Kickflip enchaîne /cart/add.js puis la page panier : la décision est
 *     écrite dans l'état AVANT de naviguer (redirectTo) et la page d'arrivée
 *     la suit.
 *  4. La vraie quantité Kickflip est la propriété « Quantité », imbriquée
 *     dans properties._mczr_attributes, PAR unité native.
 *  5. Revenir en arrière (v3) : les étapes de la barre sont cliquables ;
 *     l'aiguillage depuis le panier REMPLACE la page panier dans l'historique
 *     (le bouton retour ramène à l'étape précédente, pas au panier) ; la fiche
 *     d'une étape du parcours en cours réarme cette étape au lieu de
 *     l'abandonner (retour navigateur, étape cliquée, lien).
 */
(function () {
  'use strict';
  if (window.PackMatch && window.PackMatch.__v === 4) return;

  /* ======================================================================
     Constantes
     ====================================================================== */
  var KEY = 'packMatchState';
  var MAX_IDLE_MS = 6 * 60 * 60 * 1000;   /* parcours oublié après 6 h sans activité */
  var ARM_TTL_MS = 2 * 60 * 60 * 1000;    /* un produit armé le reste 2 h */
  var FINISHED_TTL_MS = 10 * 60 * 1000;   /* le récap du panier s'affiche dans les 10 min */

  /* Parcours proposés. Les produits sont les mêmes que dans les fonctions de
     remise : les changer ensemble. */
  /* `prix` : rappel affiché dans la barre, le MÊME que la remise (pack-match-discount). */
  function packMatch(nom, maillot, short, prix) {
    return {
      titre: 'Pack Match ' + nom,
      accroche: 'Maillot + short = ' + prix + ' € la tenue',
      etapes: [
        { handle: maillot, name: 'Le maillot', hint: 'Le haut', mot: 'maillot' },
        { handle: short, name: 'Le short', hint: 'Le bas', mot: 'short' }
      ]
    };
  }
  var PACKS = {
    rugby: packMatch('Rugby', 'maillot-de-rugby-personnalise', 'short-de-match-rugby-personnalise', 50),
    padel: packMatch('Padel', 'maillot-de-padel-personnalise', 'short-training-personnalise', 35),
    handball: packMatch('Handball', 'maillot-de-handball-personnalise', 'short-de-match-handball-personnalise', 35),
    football: packMatch('Football', 'maillot-de-foot-personnnalise', 'short-de-match-football-personnalise', 35),
    basketball: packMatch('Basketball', 'maillot-de-match-basket-personnalise', 'short-de-match-basket-personnalise', 35),
    /* Polo polyester coupé cousu + Veste zip polyester coupé cousu (sweat zippé
       à capuche) + Bas de survêtement polyester = 70 € (pack-match-discount). */
    petanque: {
      titre: 'Pack Pétanque',
      accroche: 'Polo + sweat zippé + bas = 70 € le pack',
      etapes: [
        { handle: 'polo-personnalise', name: 'Le polo', hint: 'Le haut', mot: 'polo' },
        { handle: 'veste-zip-personnalise', name: 'Le sweat zippé', hint: 'La veste', mot: 'sweat zippé', pluriel: 'sweats zippés' },
        { handle: 'bas-de-survetement', name: 'Le bas', hint: 'Le pantalon', mot: 'bas', pluriel: 'bas' }
      ]
    },
    /* 1 slip offert par débardeur Élite dès 30 débardeurs, jusqu'au 15 octobre
       2026 inclus (fin de la remise). Après, le lien mène juste au débardeur. */
    rentree: {
      titre: 'Offre de rentrée',
      accroche: 'Dès 30 débardeurs, les slips de bain sont offerts',
      offre: true,
      minimum: 30,
      fin: Date.parse('2026-10-15T21:59:59Z'),
      etapes: [
        { handle: 'maillot-basket', name: 'Le débardeur', hint: 'Le haut', mot: 'débardeur' },
        { handle: 'slip-de-bain-personnalise', name: 'Le slip', hint: 'Le dessous', mot: 'slip' }
      ]
    }
  };
  var CART_URL = '/cart';

  var isEditor = false;
  try {
    isEditor = !!(window.Shopify && window.Shopify.designMode) ||
      /\/editor|design_theme_id/.test(location.href) ||
      window.self !== window.top;
  } catch (e) { isEditor = true; }

  function now() { return Date.now(); }
  /* Nombre d'étapes du parcours (2 ou 3) ; l'étape « Récap » porte ce numéro. */
  function nb(id) { return PACKS[id].etapes.length; }
  /* Un tableau d'une case par étape, rempli avec `v`. */
  function tous(id, v) { return PACKS[id].etapes.map(function () { return v; }); }
  /* « maillot » / « maillots », « bas » / « bas »… */
  function plur(etape, n) { return n > 1 ? (etape.pluriel || etape.mot + 's') : etape.mot; }
  function packOuvert(id) {
    var p = PACKS[id];
    return !!p && !(p.fin && now() > p.fin);
  }
  /* Tournures : « ton pack » / « ton offre ». */
  function mots(id) {
    return PACKS[id] && PACKS[id].offre
      ? { ton: 'ton offre', au: 'à ton offre', quitter: 'Quitter l\'offre', complet: 'Ton offre est complète', deja: 'Ton offre est déjà complète' }
      : { ton: 'ton pack', au: 'au pack', quitter: 'Quitter le pack', complet: 'Ton pack est complet', deja: 'Ton pack est déjà complet' };
  }

  /* ======================================================================
     État
     ====================================================================== */
  function read() {
    try { var r = localStorage.getItem(KEY); return r ? JSON.parse(r) : null; } catch (e) { return null; }
  }
  function write(s) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
    return s;
  }
  /* `sport` : identifiant du parcours (un sport, ou « rentree »). */
  function blank(id) {
    return {
      v: 2, active: true, sport: id, startedAt: now(), lastActivityAt: now(),
      currentStep: 0, armed: null, seenKeys: [], seenQty: {}, redirectTo: null, finished: null
    };
  }
  /* État du parcours s'il est en cours, sinon null. Ne crée jamais rien. */
  function getActive() {
    var s = read();
    if (!s || s.active !== true || !PACKS[s.sport]) return null;
    var last = s.lastActivityAt || s.startedAt || 0;
    if (now() - last > MAX_IDLE_MS) { s.active = false; s.armed = null; write(s); return null; }
    return s;
  }
  function touch(s) { s.lastActivityAt = now(); return write(s); }
  function armedFor(s, handle) {
    if (!s || !s.armed) return null;
    if (now() - (s.armed.at || 0) > ARM_TTL_MS) return null;
    if (handle && s.armed.handle !== handle) return null;
    return s.armed;
  }
  function exitPack() {
    var s = read();
    if (s) { s.active = false; s.armed = null; s.redirectTo = null; write(s); }
  }
  /* Étape du parcours `s` dont la fiche est `handle`, -1 si aucune. */
  function stepOf(s, handle) {
    if (!s || !PACKS[s.sport] || !handle) return -1;
    var e = PACKS[s.sport].etapes;
    for (var i = 0; i < e.length; i++) if (e[i].handle === handle) return i;
    return -1;
  }
  /* Arme l'étape `i` (retour arrière, étape cliquée). Un nouvel armement
     demande de relire le panier (resync) : seuls les ajouts faits À PARTIR
     d'ici font avancer le parcours. `landed` : on est déjà sur sa fiche. */
  function armStep(s, i, landed) {
    var h = PACKS[s.sport].etapes[i].handle;
    if (!armedFor(s, h)) { s.armed = { handle: h, step: i, at: now() }; s.resync = true; }
    if (landed && !s.armed.landedAt) s.armed.landedAt = now();
    s.currentStep = i;
    s.redirectTo = null;
    return touch(s);
  }
  /* Un seul parcours guidé à la fois : en lancer un met en pause un Pack Summer
     en cours (ses produits restent au panier, il se reprend depuis son bouton
     « Composer mon pack »). */
  function pauseSummer() {
    try {
      if (window.PackSummer && window.PackSummer.exitPack) { window.PackSummer.exitPack(); return; }
      var ps = JSON.parse(localStorage.getItem('packSummerState') || 'null');
      if (ps && ps.active) {
        ps.active = false; ps.armed = null; ps.pendingMode = null; ps.replacing = null;
        localStorage.setItem('packSummerState', JSON.stringify(ps));
      }
    } catch (e) {}
  }

  /* ======================================================================
     Panier
     ====================================================================== */
  var nativeFetch = window.fetch.bind(window);

  function getCart() {
    return nativeFetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* Vraie quantité d'une ligne (voir règle 4). */
  function lineQty(item) {
    var nativeQty = (item && item.quantity) || 1;
    var props = (item && item.properties) || {};
    var raw = props._mczr_attributes;
    if (raw) {
      try {
        var attrs = JSON.parse(raw);
        if (Array.isArray(attrs)) {
          for (var a = 0; a < attrs.length; a++) {
            var k = String((attrs[a] && attrs[a].key) || '').trim().toLowerCase();
            if (k === 'quantité' || k === 'quantite' || k === 'quantity') {
              var q = parseInt(attrs[a].value, 10);
              if (!isNaN(q) && q > 0) return q * nativeQty;
            }
          }
        }
      } catch (e) {}
    }
    var keys = Object.keys(props);
    for (var i = 0; i < keys.length; i++) {
      var kk = keys[i].trim();
      if (kk === 'Quantité' || kk === 'Quantity') {
        var p = parseInt(props[keys[i]], 10);
        if (!isNaN(p) && p > 0) return p * nativeQty;
      }
    }
    return nativeQty;
  }

  /* Identité STABLE d'une ligne : la clé Shopify change quand la remise est
     recalculée (voir lineId dans pack-summer.js). */
  function lineId(item) {
    if (!item) return '';
    var props = item.properties || {};
    var names = Object.keys(props).sort();
    var str = String(item.variant_id || item.id || '') + '|' + names.map(function (n) { return n + '=' + props[n]; }).join('|');
    var h = 5381;
    for (var i = 0; i < str.length; i++) h = ((h * 33) ^ str.charCodeAt(i)) >>> 0;
    var d = props._mczr_designId;
    return (d ? 'd:' + d : 'v:' + (item.variant_id || '')) + ':' + h.toString(36);
  }

  /* Produits du parcours déjà au panier : quantité de chaque étape. */
  function analyse(cart, id) {
    var e = PACKS[id].etapes;
    var qty = tous(id, 0);
    (cart.items || []).forEach(function (it) {
      for (var i = 0; i < e.length; i++) {
        if (it.handle === e[i].handle) { qty[i] += lineQty(it); break; }
      }
    });
    return {
      qty: qty,
      filled: qty.map(function (q) { return q > 0; }),
      keys: (cart.items || []).map(lineId),
      qtys: (cart.items || []).reduce(function (m, i) { m[lineId(i)] = i.quantity; return m; }, {})
    };
  }

  /* ======================================================================
     Observation du panier (ajout Kickflip sans passer par la page panier)
     ====================================================================== */
  var CART_ROUTES = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var observerInstalled = false;
  function notifyCartChange() {
    try { document.dispatchEvent(new CustomEvent('pm:cart-changed')); } catch (e) {}
  }
  function installCartObserver() {
    if (observerInstalled) return;
    observerInstalled = true;
    var wrapped = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : ((input && input.url) || '');
      var p = wrapped.apply(this, arguments);
      if (CART_ROUTES.test(url)) p.then(notifyCartChange, function () {});
      return p;
    };
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) { this.__pmUrl = url || ''; return open.apply(this, arguments); };
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (CART_ROUTES.test(this.__pmUrl || '')) this.addEventListener('loadend', notifyCartChange);
      return send.apply(this, arguments);
    };
    ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
      document.addEventListener(ev, notifyCartChange);
    });
  }

  /* ======================================================================
     Interface : styles, loader, barre d'étapes
     ====================================================================== */
  var CSS = [
    ':root{--pm-orange:#EE6A0E;--pm-orange-soft:#FFF1E6;--pm-ink:#1d1611;--pm-muted:#7c7168;--pm-line:#efe5dc;}',
    '.pm-lock{overflow:hidden!important}',
    '@keyframes pm-fade{from{opacity:0}to{opacity:1}}',
    '@keyframes pm-slide{0%{transform:translateX(-110%)}100%{transform:translateX(260%)}}',
    '@keyframes pm-pulse{0%,100%{box-shadow:0 0 0 5px rgba(238,106,14,.16)}50%{box-shadow:0 0 0 9px rgba(238,106,14,.06)}}',

    /* Loader */
    '.pm-loader{position:fixed;inset:0;z-index:2147483647;display:grid;place-items:center;padding:24px;background:rgba(255,248,243,.94);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);animation:pm-fade .18s ease-out;font-family:inherit}',
    '.pm-loader__card{width:min(440px,100%);background:#fff;border-radius:22px;padding:30px 26px 26px;text-align:center;box-shadow:0 24px 60px rgba(238,106,14,.14),0 2px 10px rgba(29,22,17,.05)}',
    '.pm-loader__brand{font-family:var(--font-heading--family,inherit);font-weight:700;font-size:26px;line-height:1;color:var(--pm-orange);margin:0 0 22px}',
    '.pm-loader__msg{margin:22px 0 0;font-size:17px;font-weight:600;color:var(--pm-ink)}',
    '.pm-loader__sub{margin:6px 0 0;font-size:13.5px;color:var(--pm-muted)}',
    '.pm-loader__bar{position:relative;height:4px;margin-top:22px;border-radius:4px;background:#f3ebe3;overflow:hidden}',
    '.pm-loader__bar span{position:absolute;top:0;bottom:0;left:0;width:40%;border-radius:4px;background:var(--pm-orange);animation:pm-slide 1.1s cubic-bezier(.45,0,.2,1) infinite}',

    /* Étapes */
    '.pm-stepper{list-style:none;margin:0 auto;padding:0;display:flex;align-items:flex-start;justify-content:center;max-width:560px}',
    '.pm-step{position:relative;flex:1 1 0;min-width:0;display:flex;flex-direction:column;align-items:center;text-align:center}',
    '.pm-step+.pm-step:before{content:"";position:absolute;top:17px;left:-50%;right:50%;height:3px;border-radius:3px;background:var(--pm-line)}',
    '.pm-step--done+.pm-step:before{background:var(--pm-orange)}',
    '.pm-step__dot{position:relative;z-index:1;width:36px;height:36px;border-radius:50%;display:grid;place-items:center;font-size:14px;font-weight:700;background:#fff;border:2px solid var(--pm-line);color:#b3a79c}',
    '.pm-step__dot svg{width:16px;height:16px}',
    '.pm-step--done .pm-step__dot{background:var(--pm-orange);border-color:var(--pm-orange);color:#fff}',
    '.pm-step--current .pm-step__dot{border-color:var(--pm-orange);animation:pm-pulse 2s ease-in-out infinite}',
    '.pm-step--current:not(.pm-step--done) .pm-step__dot{color:var(--pm-orange)}',
    '.pm-step__text{display:flex;flex-direction:column;gap:1px;margin-top:8px;padding:0 4px;max-width:100%}',
    '.pm-step__name{font-size:13px;font-weight:700;color:var(--pm-ink);white-space:nowrap}',
    '.pm-step--todo .pm-step__name{color:#b3a79c}',
    '.pm-step__hint{font-size:11.5px;color:var(--pm-muted);white-space:nowrap}',
    '.pm-stepper--compact{max-width:260px}',
    '.pm-stepper--compact .pm-step__dot{width:30px;height:30px;font-size:13px}',
    '.pm-stepper--compact .pm-step+.pm-step:before{top:14px}',
    '.pm-step--link{cursor:pointer}',
    '.pm-step--link:hover .pm-step__dot{border-color:var(--pm-orange)}',
    '.pm-step--link:hover .pm-step__name{color:var(--pm-orange)}',
    '.pm-step--link:focus-visible{outline:2px solid var(--pm-orange);outline-offset:4px;border-radius:12px}',

    /* Barre en haut de la fiche produit et du panier */
    '.pm-bar{background:#fff;border-bottom:1px solid var(--pm-line);padding:14px 16px 18px;font-family:inherit;color:var(--pm-ink)}',
    '.pm-bar__inner{max-width:880px;margin:0 auto}',
    '.pm-bar__top{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:14px}',
    '.pm-bar__title{font-size:13px;font-weight:700;letter-spacing:.06em;text-transform:uppercase}',
    '.pm-bar__title b{color:var(--pm-orange)}',
    '.pm-bar__head{display:flex;flex-direction:column;gap:3px;min-width:0}',
    '.pm-bar__offre{font-size:13.5px;font-weight:600;color:var(--pm-orange)}',
    '.pm-bar__kicker{display:table;margin:16px auto 0;padding:6px 14px;border-radius:999px;background:var(--pm-orange-soft);color:var(--pm-orange);font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase}',
    '.pm-bar__sub{margin:10px 0 0;text-align:center;color:var(--pm-muted);font-size:15px;line-height:1.4}',
    '.pm-bar__sub strong{color:var(--pm-ink)}',
    '.pm-bar--done{background:#FFF8F3}',
    '.pm-bar--done .pm-bar__kicker{background:#EAF7EE;color:#1f7a3a}',
    '.pm-link{background:none;border:0;padding:0;font:inherit;font-size:13px;color:var(--pm-muted);text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
    '.pm-link:hover{color:var(--pm-orange)}',
    '@media (max-width:640px){.pm-step__hint{display:none}.pm-step__name{font-size:11.5px}.pm-step__dot{width:32px;height:32px}.pm-step+.pm-step:before{top:15px}.pm-bar__sub{font-size:14px}}',
    '@media (prefers-reduced-motion:reduce){.pm-loader,.pm-step--current .pm-step__dot{animation:none!important}.pm-loader__bar span{animation:none;width:100%}}'
  ].join('\n');

  function injectCss() {
    if (document.getElementById('pm-styles')) return;
    var st = document.createElement('style');
    st.id = 'pm-styles';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var CHECK = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var BAG = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 5.5h10l-.8 8H3.8L3 5.5zM5.5 5.5V4a2.5 2.5 0 015 0v1.5" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';

  /* current : 0…nb-1 = étape en cours, nb = récap ; done : une case par étape ;
     links : étapes cliquables (faites, ou la prochaine à faire ; le récap
     quand tout est fait), sauf celle où l'on est. */
  function stepperHTML(id, current, done, compact, links) {
    done = done || tous(id, false);
    var recap = nb(id);
    var suivante = done.indexOf(false);
    var html = PACKS[id].etapes.map(function (s, i) {
      var cls = ['pm-step', done[i] ? 'pm-step--done' : 'pm-step--todo'];
      if (i === current) cls.push('pm-step--current');
      var link = links && i !== current && (done[i] || i === suivante);
      if (link) cls.push('pm-step--link');
      return '<li class="' + cls.join(' ') + '"' + (i === current ? ' aria-current="step"' : '') +
        (link ? ' data-pm-step="' + i + '" role="button" tabindex="0"' : '') +
        ' aria-label="Étape ' + (i + 1) + ' : ' + esc(s.name) + (done[i] ? ' (faite)' : '') + '">' +
        '<span class="pm-step__dot">' + (done[i] ? CHECK : (i + 1)) + '</span>' +
        (compact ? '' : '<span class="pm-step__text"><span class="pm-step__name">' + esc(s.name) + '</span><span class="pm-step__hint">' + esc(s.hint) + '</span></span>') +
        '</li>';
    }).join('');
    var recapLink = links && current !== recap && suivante === -1;
    html += '<li class="pm-step' + (current === recap ? ' pm-step--current' : ' pm-step--todo') + (recapLink ? ' pm-step--link' : '') + '"' +
      (current === recap ? ' aria-current="step"' : '') +
      (recapLink ? ' data-pm-step="recap" role="button" tabindex="0" aria-label="Récap : voir le panier"' : '') + '>' +
      '<span class="pm-step__dot">' + BAG + '</span>' +
      (compact ? '' : '<span class="pm-step__text"><span class="pm-step__name">Récap</span><span class="pm-step__hint">' + (PACKS[id].offre ? 'Ton offre' : 'Ton pack') + '</span></span>') +
      '</li>';
    return '<ol class="pm-stepper' + (compact ? ' pm-stepper--compact' : '') + '">' + html + '</ol>';
  }

  function showLoader(message, opts) {
    if (isEditor) return;
    opts = opts || {};
    injectCss();
    var el = document.getElementById('pm-loader');
    if (!el) {
      el = document.createElement('div');
      el.id = 'pm-loader';
      el.className = 'pm-loader';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.documentElement.appendChild(el);
      document.documentElement.classList.add('pm-lock');
    }
    var p = PACKS[opts.id];
    el.innerHTML =
      '<div class="pm-loader__card">' +
        '<p class="pm-loader__brand">' + esc(p ? p.titre : 'Pack Match') + '</p>' +
        (p && opts.step !== undefined ? stepperHTML(opts.id, opts.step, opts.done, true) : '') +
        '<p class="pm-loader__msg">' + esc(message || 'Un instant…') + '</p>' +
        (opts.sub ? '<p class="pm-loader__sub">' + esc(opts.sub) + '</p>' : '') +
        '<div class="pm-loader__bar"><span></span></div>' +
      '</div>';
  }
  function hideLoader() {
    var el = document.getElementById('pm-loader');
    if (el) el.remove();
    document.documentElement.classList.remove('pm-lock');
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) hideLoader(); });

  /* Barre posée en haut du contenu de la page (sous l'en-tête). */
  function mountBar(html, extraClass) {
    injectCss();
    var old = document.getElementById('pm-bar');
    if (old) old.remove();
    var bar = document.createElement('div');
    bar.id = 'pm-bar';
    bar.className = 'pm-bar' + (extraClass ? ' ' + extraClass : '');
    bar.innerHTML = '<div class="pm-bar__inner">' + html + '</div>';
    var main = document.querySelector('main') || document.body;
    main.insertBefore(bar, main.firstChild);
    return bar;
  }

  /* Consigne de l'étape, selon ce qui est déjà au panier (qty = [1er, 2e]). */
  function consigne(id, step, qty) {
    var p = PACKS[id];
    var n = qty[0];
    if (p.offre) {
      if (step === 0) return 'Personnalise ton débardeur (' + p.minimum + ' minimum pour l\'offre), puis ajoute-le au panier.';
      var t = 'Personnalise ton slip, puis ajoute-le au panier.';
      if (n >= p.minimum) t += '<br>Tu as <strong>' + n + ' débardeurs</strong> : prends ' + n + ' slips, ils sont offerts.';
      else if (n > 0) t += '<br>Tu as <strong>' + n + ' débardeur' + (n > 1 ? 's' : '') + '</strong> : il t\'en faut encore ' + (p.minimum - n) + ' pour que les slips soient offerts.';
      return t;
    }
    var txt = 'Personnalise ton ' + p.etapes[step].mot + ', puis ajoute-le au panier.';
    if (step > 0 && n > 0) {
      txt += '<br>Tu as <strong>' + n + ' ' + plur(p.etapes[0], n) + '</strong> au panier : prends autant de ' + plur(p.etapes[step], 2) + ' pour que chaque tenue soit au prix du pack.';
    }
    return txt;
  }
  /* Étape déjà faite (retour arrière) : on peut en rajouter, ou continuer vers
     la première étape qui reste à faire (le récap s'il n'en reste pas). */
  function dejaFait(id, step, qty) {
    var p = PACKS[id];
    var n = qty[step];
    if (!(n > 0)) return '';
    var suite = 'Récap';
    for (var i = 0; i < p.etapes.length; i++) {
      if (i !== step && !(qty[i] > 0)) { suite = p.etapes[i].name; break; }
    }
    return '<br>Tu as déjà <strong>' + n + ' ' + esc(plur(p.etapes[step], n)) + '</strong> au panier : ajoutes-en ici, ou clique sur « ' + esc(suite) + ' » pour continuer.';
  }
  /* Récap du panier : { ok, kicker, texte }. */
  function bilan(id, qty) {
    var p = PACKS[id];
    if (p.offre) {
      if (qty[0] >= p.minimum) {
        var offerts = Math.min(qty[0], qty[1]);
        return { ok: true, kicker: mots(id).complet, texte: 'Tes <strong>' + offerts + ' slip' + (offerts > 1 ? 's' : '') + ' de bain</strong> ' + (offerts > 1 ? 'sont offerts' : 'est offert') + ' dans ton panier.' };
      }
      var manque = p.minimum - qty[0];
      return { ok: false, kicker: 'Encore ' + manque + ' débardeur' + (manque > 1 ? 's' : ''), texte: 'Il te manque <strong>' + manque + ' débardeur' + (manque > 1 ? 's' : '') + '</strong> pour que les slips soient offerts (' + p.minimum + ' minimum).' };
    }
    return { ok: true, kicker: mots(id).complet, texte: 'Le prix du ' + esc(p.titre) + ' est appliqué dans ton panier, ligne « ' + esc(p.titre) + ' ».' };
  }

  /* ======================================================================
     Navigation dans le parcours
     ====================================================================== */
  /* `replace` : la page quittée ne reste pas dans l'historique. Sert à la page
     panier traversée après un ajout, sinon le bouton retour y ramène. */
  function go(url, delay, replace) {
    setTimeout(function () {
      if (replace) window.location.replace(url);
      else window.location.href = url;
    }, delay || 0);
  }
  function productUrl(handle) { return '/products/' + handle; }
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }

  /* Démarrer (ou reprendre) un parcours depuis son bouton ou son lien.
     `replace` : lancé depuis une fiche (lien « ?parcours= »), qu'on remplace. */
  function startPack(id, replace) {
    var p = PACKS[id];
    if (!packOuvert(id) || isEditor) return;
    pauseSummer();
    var s = blank(id);
    write(s);
    showLoader('On prépare ' + mots(id).ton, { id: id, step: 0, done: tous(id, false) });
    getCart().then(function (cart) {
      var a = analyse(cart, id);
      s.seenKeys = a.keys; s.seenQty = a.qtys;
      var next = a.filled.indexOf(false);
      if (next === -1) {
        s.active = false; s.finished = { sport: id, at: now(), qty: a.qty };
        touch(s);
        showLoader(mots(id).deja, { id: id, step: nb(id), done: a.filled });
        go(CART_URL, 350, replace);
        return;
      }
      s.currentStep = next;
      s.armed = { handle: p.etapes[next].handle, step: next, at: now() };
      touch(s);
      showLoader(next === 0 ? 'C\'est parti !' : 'On reprend où tu t\'étais arrêté',
        { id: id, step: next, done: a.filled, sub: 'Étape ' + (next + 1) + ' sur ' + nb(id) + ' — ' + p.etapes[next].name.toLowerCase() });
      go(productUrl(s.armed.handle), 350, replace);
    }).catch(function () {
      s.armed = { handle: p.etapes[0].handle, step: 0, at: now() };
      touch(s);
      go(productUrl(p.etapes[0].handle), 0, replace);
    });
  }

  /* Étape cliquée dans la barre (fiche produit ou récap du panier) : on va sur
     la fiche de cette étape, armée. « recap » : le panier, avec son récap.
     Depuis le récap, le parcours terminé se rouvre à cette étape. */
  function goToStep(target) {
    var s = getActive();
    if (!s) {
      s = read();
      if (!s || !PACKS[s.sport] || isEditor) return;
      s.active = true; s.finished = null;
    }
    var id = s.sport;
    var p = PACKS[id];
    if (target === 'recap') {
      showLoader('On ouvre ' + mots(id).ton, { id: id, step: nb(id), done: tous(id, true) });
      getCart().then(function (cart) { return analyse(cart, id).qty; })
        .catch(function () { return tous(id, 0); })
        .then(function (qty) {
          s.active = false; s.armed = null; s.redirectTo = null;
          s.finished = { sport: id, at: now(), qty: qty };
          touch(s);
          go(CART_URL);
        });
      return;
    }
    var i = parseInt(target, 10);
    if (!p.etapes[i]) return;
    armStep(s, i, false);
    showLoader('On revient à ton ' + p.etapes[i].mot, { id: id, step: i });
    go(productUrl(p.etapes[i].handle));
  }
  /* Relie les étapes cliquables d'une barre. */
  function bindSteps(bar) {
    var els = bar.querySelectorAll('[data-pm-step]');
    for (var k = 0; k < els.length; k++) {
      (function (el) {
        function activate() { goToStep(el.getAttribute('data-pm-step')); }
        el.addEventListener('click', activate);
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
        });
      })(els[k]);
    }
  }

  /* ======================================================================
     Page : accueil (boutons « Composer mon pack » et liens « ?parcours= »)
     ====================================================================== */
  function packDuLien(el) {
    var id = el.getAttribute('data-pack-match-start');
    if (id) return id;
    var m = (el.getAttribute('href') || '').match(/[?&]parcours=([a-z]+)/);
    return m ? m[1] : null;
  }
  function initHome(root) {
    if (isEditor) return;
    var els = (root || document).querySelectorAll('[data-pack-match-start], a[href*="parcours="]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].getAttribute('data-pm-bound') === '1') continue;
      els[i].setAttribute('data-pm-bound', '1');
      els[i].addEventListener('click', function (e) {
        var id = packDuLien(this);
        if (!packOuvert(id)) return;   /* inconnu ou terminé : le lien mène à la fiche */
        e.preventDefault();
        e.stopImmediatePropagation();
        startPack(id);
      }, true);
    }
  }

  /* ======================================================================
     Page : fiche produit
     ====================================================================== */
  function initProduct() {
    if (isEditor) return;
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    /* Lien « ?parcours=… » suivi avant que son bouton soit relié (clic très
       rapide) : le parcours démarre ici. */
    var demande = (location.search.match(/[?&]parcours=([a-z]+)/) || [])[1];
    if (demande && packOuvert(demande) && !armedFor(getActive(), handle)) { startPack(demande, true); return; }

    var s = getActive();
    if (!s) return;
    if (!armedFor(s, handle)) return;   /* produit ouvert hors parcours : aucune barre */

    touch(s);
    /* Si Kickflip ajoute au panier sans passer par /cart, on aiguille d'ici. */
    installCartObserver();
    var fallback = null;
    document.addEventListener('pm:cart-changed', function () {
      clearTimeout(fallback);
      fallback = setTimeout(function () { routeArmed(false); }, 2500);
    });
    /* Retour navigateur servi depuis le cache (bfcache) : le script ne se
       relance pas. Fiche d'une étape du parcours en cours : on réarme cette
       étape et on redessine la barre ; sinon on retire la barre. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var st = getActive();
      var i = stepOf(st, handle);
      if (i !== -1) { armStep(st, i, true); renderBar(handle); return; }
      var b = document.getElementById('pm-bar');
      if (b) b.remove();
    });
    renderBar(handle);
  }

  /* Barre d'étapes de la fiche `handle`, d'après l'état et le panier. */
  function renderBar(handle) {
    var s = getActive();
    var armed = armedFor(s, handle);
    if (!armed) return;
    var id = s.sport;
    var p = PACKS[id];
    var step = armed.step;
    getCart().then(function (cart) { return analyse(cart, id); })
      .catch(function () { return null; })
      .then(function (a) {
        /* Étape réarmée : seuls les ajouts faits à partir d'ici comptent. */
        var st = read();
        if (a && st && st.resync) { st.seenKeys = a.keys; st.seenQty = a.qtys; st.resync = false; write(st); }
        a = a || { qty: tous(id, 0), filled: tous(id, false) };
        var bar = mountBar(
          '<div class="pm-bar__top">' +
            '<span class="pm-bar__head">' +
              '<span class="pm-bar__title">' + esc(p.titre) + ' · <b>Étape ' + (step + 1) + ' sur ' + nb(id) + '</b></span>' +
              (p.accroche ? '<span class="pm-bar__offre">' + esc(p.accroche) + '</span>' : '') +
            '</span>' +
            '<button type="button" class="pm-link" data-pm-quit>' + esc(mots(id).quitter) + '</button>' +
          '</div>' +
          stepperHTML(id, step, a.filled, false, true) +
          '<span class="pm-bar__kicker">Étape ' + (step + 1) + ' sur ' + nb(id) + ' · ' + esc(p.etapes[step].name) + '</span>' +
          '<p class="pm-bar__sub">' + consigne(id, step, a.qty) + dejaFait(id, step, a.qty) + '</p>'
        );
        bar.querySelector('[data-pm-quit]').addEventListener('click', function () {
          exitPack();
          bar.remove();
        });
        bindSteps(bar);
      });
  }

  /* ======================================================================
     Page : panier (aiguillage après ajout, puis récap)
     ====================================================================== */
  var routing = false;
  function followPending(s) {
    var r = s && s.redirectTo;
    if (!r || !r.url) return false;
    s.redirectTo = null; write(s);
    if (now() - (r.at || 0) > 2 * 60 * 1000) return false;
    if (location.pathname === r.url.split('#')[0]) return false;
    routing = true;
    showLoader(r.msg || 'Un instant…', r.opts || {});
    go(r.url, 150, onCartPage());
    return true;
  }
  function routeArmed(early) {
    if (isEditor || routing) return;
    var s = getActive();
    if (!s) return;
    if (followPending(s)) return;
    var armed = armedFor(s);
    if (!armed) return;   /* rien d'armé : panier normal, aucune redirection */

    routing = true;
    var id = s.sport;
    var p = PACKS[id];
    var etape = p.etapes[armed.step] || p.etapes[0];
    if (early) showLoader('On ajoute ton ' + etape.mot + ' ' + mots(id).au, { id: id, step: armed.step });

    getCart().then(function (cart) {
      var seen = Array.isArray(s.seenKeys) ? s.seenKeys : [];
      var seenQty = s.seenQty || {};
      var fresh = (cart.items || []).filter(function (it) {
        return it.handle === armed.handle && seen.indexOf(lineId(it)) === -1;
      });
      /* même design rajouté tel quel : Shopify fusionne dans la ligne existante */
      var grown = (cart.items || []).filter(function (it) {
        var lid = lineId(it);
        return it.handle === armed.handle && seen.indexOf(lid) !== -1 &&
          seenQty[lid] != null && it.quantity > seenQty[lid];
      });
      if (!fresh.length && !grown.length) {   /* pas l'ajout attendu : on ne touche à rien */
        if (early) hideLoader();
        routing = false;
        return;
      }
      var a = analyse(cart, id);
      s.seenKeys = a.keys; s.seenQty = a.qtys; s.armed = null;
      var next = a.filled.indexOf(false);
      var rd;
      if (next === -1) {
        s.active = false;
        s.finished = { sport: id, at: now(), qty: a.qty };
        rd = { url: CART_URL, msg: mots(id).complet + ' 🎉', opts: { id: id, step: nb(id), done: a.filled } };
      } else {
        s.currentStep = next;
        s.armed = { handle: p.etapes[next].handle, step: next, at: now() };
        rd = { url: productUrl(s.armed.handle), msg: 'C\'est ajouté !', opts: { id: id, step: next, done: a.filled, sub: 'Étape suivante : ' + p.etapes[next].name.toLowerCase() } };
      }
      if (location.pathname === rd.url) {   /* déjà sur le panier : le récap s'affiche ici */
        touch(s);
        hideLoader();
        routing = false;
        showFinished();
        return;
      }
      rd.at = now();
      s.redirectTo = rd;   /* écrit AVANT de naviguer : voir followPending */
      touch(s);
      showLoader(rd.msg, rd.opts);
      /* depuis le panier traversé après l'ajout : il ne reste pas dans
         l'historique, le bouton retour ramène à l'étape d'avant */
      go(rd.url, early ? 450 : 0, onCartPage());
    }).catch(function (e) {
      console.error('[PackMatch] aiguillage panier :', e);
      hideLoader();
      routing = false;
    });
  }

  /* Récap : le panier, avec la remise du parcours appliquée. */
  function showFinished() {
    var s = read();
    var f = s && s.finished;
    if (!f || !PACKS[f.sport] || now() - (f.at || 0) > FINISHED_TTL_MS) return;
    s.finished = null; write(s);   /* affiché une fois */
    var p = PACKS[f.sport];
    var b = bilan(f.sport, f.qty || tous(f.sport, 0));
    var bar = mountBar(
      '<div class="pm-bar__top">' +
        '<span class="pm-bar__title">' + esc(p.titre) + ' · <b>Récap</b></span>' +
        '<button type="button" class="pm-link" data-pm-close>Fermer</button>' +
      '</div>' +
      stepperHTML(f.sport, nb(f.sport), tous(f.sport, true), false, true) +
      '<span class="pm-bar__kicker">' + esc(b.kicker) + '</span>' +
      '<p class="pm-bar__sub">' + b.texte + '</p>',
      b.ok ? 'pm-bar--done' : ''
    );
    bar.querySelector('[data-pm-close]').addEventListener('click', function () { bar.remove(); });
    bindSteps(bar);
  }

  function initCartRouter() {
    if (isEditor) return;
    var s = read();
    if (s && !s.active && s.finished) {
      if (s.redirectTo) { s.redirectTo = null; write(s); }
      showFinished();
      return;
    }
    routeArmed(true);
  }

  /* ======================================================================
     Nettoyage au chargement
     ====================================================================== */
  /* Armement abandonné : le client a lancé un parcours puis est parti ailleurs
     sans ajouter. L'armement ne survit que sur les fiches des étapes du
     parcours en cours et sur le panier. Arriver sur la fiche d'une AUTRE étape
     de ce parcours (retour navigateur, étape cliquée, lien) arme cette étape :
     on reprend le parcours là, au lieu de l'abandonner. */
  (function dropStaleArming() {
    if (isEditor) return;
    var s = read();
    if (!s) return;
    var path = location.pathname.replace(/\/$/, '');
    var pm = path.match(/\/products\/([^/?#]+)/);
    var active = getActive();
    var i = pm ? stepOf(active, decodeURIComponent(pm[1])) : -1;
    if (i !== -1) { armStep(active, i, true); return; }
    s = read();
    if (!s || !s.armed) return;
    if (/\/cart$/.test(path) && s.armed.landedAt) return;
    s.armed = null;
    write(s);
  })();

  /* Arrivé sur la page visée : la décision est honorée, on l'efface. */
  (function () {
    var s = read();
    if (s && s.redirectTo && s.redirectTo.url && location.pathname === s.redirectTo.url.split('#')[0]) {
      s.redirectTo = null; write(s);
    }
  })();

  window.PackMatch = {
    __v: 4,
    initHome: initHome,
    initProduct: initProduct,
    initCartRouter: initCartRouter,
    startPack: startPack,
    exitPack: exitPack,
    goToStep: goToStep,
    /* exposés pour les tests */
    _analyse: analyse,
    _lineQty: lineQty,
    _stepperHTML: stepperHTML,
    _packOuvert: packOuvert
  };
})();
